module.exports = __webpack_public_path__ + "img/cursor.14d39b3a.svg";